import PatientView from "../Components/FirstComponents/PatientsView";
import Banner from "../Utils/Banner";

function Testimonials() {
  return (
    <div className="w-full overflow-x-hidden">
      <div
        className="bg-gray-200 bg-no-repeat bg-contain w-full"
        style={{
          backgroundImage: "url('/assets/background.png')",
          backgroundPosition: "right top",
        }}
      >
        <Banner title="Testimonials" />

        <div className="mx-auto max-w-7xl w-full overflow-x-hidden">
          <div className="px-4 sm:px-6 lg:px-8 mt-6 sm:mt-8 mb-10">
            <PatientView />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Testimonials;
